import Cookies from 'js-cookie'

export function getCookie(cname: string) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim()
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
  }
  return ''
}

export const setCookie = (key, val) => {
  if (window) {
    const temp = window?.location?.host?.split('.')?.reverse()
    const root_domain = '.' + temp[1] + '.' + temp[0]
    if (process.env.envType !== 'development') {
      Cookies.set(key, val, {
        domain: root_domain,
      })
    } else {
      Cookies.set(key, val)
    }
  }
}

export const removeCookie = (key) => {
  if (window) {
    const temp = window?.location?.host?.split('.')?.reverse()
    const root_domain = '.' + temp[1] + '.' + temp[0]
    if (process.env.envType !== 'development') {
      Cookies.remove(key, { domain: root_domain })
    } else {
      Cookies.remove(key)
    }
  }
}


export function getNowFormatDate() {
  let date = new Date()
  let year  = date.getFullYear() //获取完整的年份(4位)
  let month :string | number = date.getMonth() + 1 //获取当前月份(0-11,0代表1月)
  let  strDate:string | number = date.getDate() // 获取当前日(1-31)
  if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
  if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0
  return `${year}-${month}-${strDate}`
}